import React from 'react';
import { teacher_assignment_question_path, teacher_submission_path } from '@/modules/routes';
import useGradingStore from '@/components/staffer/Grading/useGradingStore';
import GradingSelect from '@/components/shared/Grading/Navigation/GradingSelect';
import { gradingNavigationParams } from '@/components/staffer/Grading/utils';

type ViewByOptions = 'student' | 'question';

const BottomRowFilters = () => {
  const { assignment, classroom, isQuestionMode, setFilter } = useGradingStore();

  const baseGradingSelectProps = {
    'aria-label': 'dropdown-toggle',
    labelClass: 'tw-text-xs',
    useCookie: true,
  };

  const onViewByChange = (value: ViewByOptions) => {
    if (value === 'question') {
      const questionId = assignment.questions[0]?.id;
      window.location.assign(
        teacher_assignment_question_path(
          assignment.id,
          { id: questionId },
          { params: gradingNavigationParams() },
        ),
      );
      return;
    }

    const submissionId = classroom.students.find(s => s.submission_id)?.submission_id;
    if (submissionId) {
      window.location.assign(
        teacher_submission_path(submissionId, { params: gradingNavigationParams() }),
      );
    }
  };

  const viewByStudentOption = {
    isDisabled: !isQuestionMode,
    label: 'Student',
    value: 'student',
  };
  const viewByQuestionOption = {
    isDisabled: isQuestionMode,
    label: 'Question',
    value: 'question',
  };

  return (
    <>
      <GradingSelect
        {...baseGradingSelectProps}
        defaultValue={isQuestionMode ? viewByQuestionOption : viewByStudentOption}
        id="view-by-toggle"
        label="View By"
        options={[viewByStudentOption, viewByQuestionOption]}
        selectClass="tw-min-w-[110px] tw-ml-1"
        onChange={({ value }) => onViewByChange(value as ViewByOptions)}
      />
      <GradingSelect
        {...baseGradingSelectProps}
        id="questions-toggle"
        label={isQuestionMode ? 'Student Responses' : 'Questions'}
        options={[
          { label: 'All', value: 'all' },
          { label: 'Answered', value: 'answered' },
          { label: 'Unanswered', value: 'unanswered' },
        ]}
        selectClass="tw-min-w-[130px] tw-ml-1"
        onChange={({ value }) => setFilter({ questionsFilter: value })}
      />
      <GradingSelect
        {...baseGradingSelectProps}
        id="answer-key-toggle"
        label="Answer Keys"
        options={[{ label: 'Show', value: 'show' }, { label: 'Hide', value: 'hide' }]}
        selectClass="tw-min-w-[90px] tw-ml-1"
        onChange={({ value }) => setFilter({ answerKeyFilter: value })}
      />
      {!isQuestionMode && (
        <GradingSelect
          {...baseGradingSelectProps}
          id="auto-graded-toggle"
          label="Auto-graded"
          options={[{ label: 'Show', value: 'show' }, { label: 'Hide', value: 'hide' }]}
          selectClass="tw-min-w-[100px] tw-ml-1"
          onChange={({ value }) => setFilter({ autoGradedFilter: value })}
        />
      )}
      <GradingSelect
        {...baseGradingSelectProps}
        id="status-toggle"
        label="Status"
        options={[
          { label: 'All', value: 'all' },
          { label: 'Ungraded', value: 'ungraded' },
          { label: 'Graded', value: 'graded' },
        ]}
        selectClass="tw-min-w-[120px] tw-ml-1"
        onChange={({ value }) => setFilter({ statusFilter: value })}
      />
    </>
  );
};

export default BottomRowFilters;
